import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .settings-header {
    font-size: 20px;
    cursor: default;
  }

  p.error {
    color: ${(props) => props.theme.colors.red};
  }

  p.warning {
    color: ${(props) => props.theme.colors.orange};
  }

  .hidden {
    display: none;
  }

  .time-zone-label {
    font-size: 13px;
    margin: auto 0;
    line-height: 18px;
    cursor: default;
  }
`;

const BlockContainer = styled.div`
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.inactive};
  padding: 16px;
  margin-bottom: 16px;
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  cursor: default;
`;

export default {
  Wrapper,
  RowContainer,
  BlockContainer,
  ErrorMessage,
};
